import React, { useState } from 'react'
import ReactApexChart from 'react-apexcharts'

const CompleteAnalytics = () => {


const [data,setdata] = useState({
  
    series: [{
      name: 'Net Profit',
      data: [44, 55, 57]
    }, {
      name: 'Revenue',
      data: [76, 85, 101]
    }, {
      name: 'Free Cash Flow',
      data: [35, 41, 36]
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Feb', 'Mar', 'Apr'],
      },
      yaxis: {
        title: {
          text: '$ (thousands)'
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands"
          }
        }
      }
    },
  
  
  })

  return (
   
   <>
   
   <div className="container-fluid">

          <div className="row">
            <div className="col-xxl-5">
              <div className="d-flex flex-column h-100">
               
                {/* end row*/}
                <div className="row">
                  <div className="col-md-6">
                    <div className="card card-animate">
                      <div className="card-body">
                        <div className="d-flex justify-content-between">
                          <div>
                            <p className="fw-medium text-muted mb-0">Users</p>
                            <h2 className="mt-4 ff-secondary fw-semibold">
                              <span
                                className="counter-value"
                                data-target="28.05"
                              >
                                28.05
                              </span>
                              k
                            </h2>
                            <p className="mb-0 text-muted">
                              <span className="badge bg-light text-success mb-0">
                                <i className="ri-arrow-up-line align-middle" />{" "}
                                16.24 %
                              </span>{" "}
                              vs. previous month
                            </p>
                          </div>
                          <div>
                            <div className="avatar-sm flex-shrink-0">
                              <span className="avatar-title bg-primary rounded-circle fs-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-users"
                                >
                                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                  <circle cx={9} cy={7} r={4} />
                                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* end card body */}
                    </div>{" "}
                    {/* end card*/}
                  </div>{" "}
                  {/* end col*/}
                  <div className="col-md-6">
                    <div className="card card-animate">
                      <div className="card-body">
                        <div className="d-flex justify-content-between">
                          <div>
                            <p className="fw-medium text-muted mb-0">
                              Sessions
                            </p>
                            <h2 className="mt-4 ff-secondary fw-semibold">
                              <span
                                className="counter-value"
                                data-target="97.66"
                              >
                                97.66
                              </span>
                              k
                            </h2>
                            <p className="mb-0 text-muted">
                              <span className="badge bg-light text-danger mb-0">
                                <i className="ri-arrow-down-line align-middle" />{" "}
                                3.96 %
                              </span>{" "}
                              vs. previous month
                            </p>
                          </div>
                          <div>
                            <div className="avatar-sm flex-shrink-0">
                              <span className="avatar-title bg-danger rounded-circle fs-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-activity"
                                >
                                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* end card body */}
                    </div>{" "}
                    {/* end card*/}
                  </div>{" "}
                  {/* end col*/}
                </div>{" "}
                {/* end row*/}
                <div className="row">
                  <div className="col-md-6">
                    <div className="card card-animate">
                      <div className="card-body">
                        <div className="d-flex justify-content-between">
                          <div>
                            <p className="fw-medium text-muted mb-0">
                              Avg. Visit Duration
                            </p>
                            <h2 className="mt-4 ff-secondary fw-semibold">
                              <span className="counter-value" data-target={3}>
                                3
                              </span>
                              m
                              <span className="counter-value" data-target={40}>
                                40
                              </span>
                              sec
                            </h2>
                            <p className="mb-0 text-muted">
                              <span className="badge bg-light text-danger mb-0">
                                <i className="ri-arrow-down-line align-middle" />{" "}
                                0.24 %
                              </span>{" "}
                              vs. previous month
                            </p>
                          </div>
                          <div>
                            <div className="avatar-sm flex-shrink-0">
                              <span className="avatar-title bg-warning rounded-circle fs-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-clock"
                                >
                                  <circle cx={12} cy={12} r={10} />
                                  <polyline points="12 6 12 12 16 14" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* end card body */}
                    </div>{" "}
                    {/* end card*/}
                  </div>{" "}
                  {/* end col*/}
                  <div className="col-md-6">
                    <div className="card card-animate">
                      <div className="card-body">
                        <div className="d-flex justify-content-between">
                          <div>
                            <p className="fw-medium text-muted mb-0">
                              Bounce Rate
                            </p>
                            <h2 className="mt-4 ff-secondary fw-semibold">
                              <span
                                className="counter-value"
                                data-target="33.48"
                              >
                                33.48
                              </span>
                              %
                            </h2>
                            <p className="mb-0 text-muted">
                              <span className="badge bg-light text-success mb-0">
                                <i className="ri-arrow-up-line align-middle" />{" "}
                                7.05 %
                              </span>{" "}
                              vs. previous month
                            </p>
                          </div>
                          <div>
                            <div className="avatar-sm flex-shrink-0">
                              <span className="avatar-title bg-success rounded-circle fs-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-external-link"
                                >
                                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                  <polyline points="15 3 21 3 21 9" />
                                  <line x1={10} y1={14} x2={21} y2={3} />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* end card body */}
                    </div>{" "}
                    {/* end card*/}
                  </div>{" "}
                  {/* end col*/}
                </div>{" "}
                {/* end row*/}
              </div>
            </div>{" "}
            {/* end col*/}
            <div className="col-xxl-7">
              <div className="row h-100">
                <div className="col-xl-6">
                  <div className="card card-height-100">
                    <div className="card-header align-items-center d-flex">
                      <h4 className="card-title mb-0 flex-grow-1">
                        Classes
                      </h4>
                      <div className="flex-shrink-0">
                        <button
                          type="button"
                          className="btn btn-soft-primary btn-sm shadow-none"
                        >
                          Export Report
                        </button>
                      </div>
                    </div>
                    {/* end card header */}
                    {/* card body */}
                    <div className="card-body">
                      
                      <div className="table-responsive table-card ">
                        <table className="table table-borderless table-sm table-centered align-middle table-nowrap mb-1">
                          <thead className="text-muted border-dashed border border-start-0 border-end-0 bg-light-subtle">
                            <tr>
                              <th>Duration (Secs)</th>
                              <th style={{ width: "30%" }}>Sessions</th>
                              <th style={{ width: "30%" }}>Views</th>
                            </tr>
                          </thead>
                          <tbody className="border-0">
                            <tr>
                              <td>0-30</td>
                              <td>2,250</td>
                              <td>4,250</td>
                            </tr>
                            <tr>
                              <td>31-60</td>
                              <td>1,501</td>
                              <td>2,050</td>
                            </tr>
                            <tr>
                              <td>61-120</td>
                              <td>750</td>
                              <td>1,600</td>
                            </tr>
                            <tr>
                              <td>121-240</td>
                              <td>540</td>
                              <td>1,040</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}
                <div className="col-xl-6">
                <div className="card card-height-100">
                <div className="card-header align-items-center d-flex">
                  <h4 className="card-title mb-0 flex-grow-1">Top Pages</h4>
                  <div className="flex-shrink-0">
                    <div className="dropdown card-header-dropdown">
                      <a
                        className="text-reset dropdown-btn"
                        href="#"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span className="text-muted fs-16">
                          <i className="mdi mdi-dots-vertical align-middle" />
                        </span>
                      </a>
                      <div className="dropdown-menu dropdown-menu-end">
                        <a className="dropdown-item" href="#">
                          Today
                        </a>
                        <a className="dropdown-item" href="#">
                          Last Week
                        </a>
                        <a className="dropdown-item" href="#">
                          Last Month
                        </a>
                        <a className="dropdown-item" href="#">
                          Current Year
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* end card header */}
                <div className="card-body">
                  <div className="table-responsive table-card">
                    <table className="table align-middle table-borderless table-centered table-nowrap mb-0">
                      <thead className="text-muted table-light">
                        <tr>
                          <th scope="col" style={{ width: 62 }}>
                            Active Page
                          </th>
                          <th scope="col">Active</th>
                          <th scope="col">Users</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <a href="javascript:void(0);">
                              /themesbrand/skote-25867
                            </a>
                          </td>
                          <td>99</td>
                          <td>25.3%</td>
                        </tr>
                        {/* end */}
                        <tr>
                          <td>
                            <a href="javascript:void(0);">
                              /dashonic/chat-24518
                            </a>
                          </td>
                          <td>86</td>
                          <td>22.7%</td>
                        </tr>
                        {/* end */}
                        <tr>
                          <td>
                            <a href="javascript:void(0);">
                              /skote/timeline-27391
                            </a>
                          </td>
                          <td>64</td>
                          <td>18.7%</td>
                        </tr>
                        {/* end */}
                       
                       
                        <tr>
                          <td>
                            <a href="javascript:void(0);">/doot/chats-29964</a>
                          </td>
                          <td>20</td>
                          <td>10.9%</td>
                        </tr>
                        {/* end */}
                        <tr>
                          <td>
                            <a href="javascript:void(0);">
                              /minton/pages-29739
                            </a>
                          </td>
                          <td>10</td>
                          <td>07.3%</td>
                        </tr>
                        {/* end */}
                      </tbody>
                      {/* end tbody */}
                    </table>
                    {/* end table */}
                  </div>
                  {/* end */}
                </div>
                {/* end cardbody */}
              </div>
              {/* end card */}
                  {/* end card */}
                </div>{" "}
                {/* end col*/}
              </div>{" "}
              {/* end row*/}
            </div>
            {/* end col */}
          </div>{" "}
          {/* end row*/}







































 {/* end row */}
 <div className="row">
            <div className="col-xl-4">
              <div className="card card-height-100">
                <div className="card-header align-items-center d-flex">
                  <h4 className="card-title mb-0 flex-grow-1">
                    Users by Device
                  </h4>
                  <div className="flex-shrink-0">
                    <div className="dropdown card-header-dropdown">
                      <a
                        className="text-reset dropdown-btn"
                        href="#"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span className="text-muted fs-16">
                          <i className="mdi mdi-dots-vertical align-middle" />
                        </span>
                      </a>
                      <div className="dropdown-menu dropdown-menu-end">
                        <a className="dropdown-item" href="#">
                          Today
                        </a>
                        <a className="dropdown-item" href="#">
                          Last Week
                        </a>
                        <a className="dropdown-item" href="#">
                          Last Month
                        </a>
                        <a className="dropdown-item" href="#">
                          Current Year
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* end card header */}
                <div className="card-body">
                  <div
                    id="user_device_pie_charts"
                    data-colors='["--vz-primary", "--vz-warning", "--vz-info"]'
                    className="apex-charts"
                    dir="ltr"
                    style={{ minHeight: "201.8px" }}
                  >
                    <div
                      id="apexchartszx11mu42"
                      className="apexcharts-canvas apexchartszx11mu42 apexcharts-theme-light"
                      style={{ width: 434, height: "201.8px" }}
                    >
                     
                      <div className="apexcharts-tooltip apexcharts-theme-dark">
                        <div
                          className="apexcharts-tooltip-series-group"
                          style={{ order: 1 }}
                        >
                          <span
                            className="apexcharts-tooltip-marker"
                            style={{ backgroundColor: "rgb(75, 56, 179)" }}
                          />
                          <div
                            className="apexcharts-tooltip-text"
                            style={{
                              fontFamily: "Helvetica, Arial, sans-serif",
                              fontSize: 12
                            }}
                          >
                            <div className="apexcharts-tooltip-y-group">
                              <span className="apexcharts-tooltip-text-y-label" />
                              <span className="apexcharts-tooltip-text-y-value" />
                            </div>
                            <div className="apexcharts-tooltip-goals-group">
                              <span className="apexcharts-tooltip-text-goals-label" />
                              <span className="apexcharts-tooltip-text-goals-value" />
                            </div>
                            <div className="apexcharts-tooltip-z-group">
                              <span className="apexcharts-tooltip-text-z-label" />
                              <span className="apexcharts-tooltip-text-z-value" />
                            </div>
                          </div>
                        </div>
                        <div
                          className="apexcharts-tooltip-series-group"
                          style={{ order: 2 }}
                        >
                          <span
                            className="apexcharts-tooltip-marker"
                            style={{ backgroundColor: "rgb(255, 190, 11)" }}
                          />
                          <div
                            className="apexcharts-tooltip-text"
                            style={{
                              fontFamily: "Helvetica, Arial, sans-serif",
                              fontSize: 12
                            }}
                          >
                            <div className="apexcharts-tooltip-y-group">
                              <span className="apexcharts-tooltip-text-y-label" />
                              <span className="apexcharts-tooltip-text-y-value" />
                            </div>
                            <div className="apexcharts-tooltip-goals-group">
                              <span className="apexcharts-tooltip-text-goals-label" />
                              <span className="apexcharts-tooltip-text-goals-value" />
                            </div>
                            <div className="apexcharts-tooltip-z-group">
                              <span className="apexcharts-tooltip-text-z-label" />
                              <span className="apexcharts-tooltip-text-z-value" />
                            </div>
                          </div>
                        </div>
                        <div
                          className="apexcharts-tooltip-series-group"
                          style={{ order: 3 }}
                        >
                          <span
                            className="apexcharts-tooltip-marker"
                            style={{ backgroundColor: "rgb(41, 156, 219)" }}
                          />
                          <div
                            className="apexcharts-tooltip-text"
                            style={{
                              fontFamily: "Helvetica, Arial, sans-serif",
                              fontSize: 12
                            }}
                          >
                            <div className="apexcharts-tooltip-y-group">
                              <span className="apexcharts-tooltip-text-y-label" />
                              <span className="apexcharts-tooltip-text-y-value" />
                            </div>
                            <div className="apexcharts-tooltip-goals-group">
                              <span className="apexcharts-tooltip-text-goals-label" />
                              <span className="apexcharts-tooltip-text-goals-value" />
                            </div>
                            <div className="apexcharts-tooltip-z-group">
                              <span className="apexcharts-tooltip-text-z-label" />
                              <span className="apexcharts-tooltip-text-z-value" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive mt-3">
                    <table className="table table-borderless table-sm table-centered align-middle table-nowrap mb-0">
                      <tbody className="border-0">
                        <tr>
                          <td>
                            <h4 className="text-truncate fs-14 fs-medium mb-0">
                              <i className="ri-stop-fill align-middle fs-18 text-primary me-2" />
                              Desktop Users
                            </h4>
                          </td>
                          <td>
                            <p className="text-muted mb-0">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-users me-2 icon-sm"
                              >
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                <circle cx={9} cy={7} r={4} />
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                              </svg>
                              78.56k
                            </p>
                          </td>
                          <td className="text-end">
                            <p className="text-success fw-medium fs-12 mb-0">
                              <i className="ri-arrow-up-s-fill fs-5 align-middle" />
                              2.08%
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h4 className="text-truncate fs-14 fs-medium mb-0">
                              <i className="ri-stop-fill align-middle fs-18 text-warning me-2" />
                              Mobile Users
                            </h4>
                          </td>
                          <td>
                            <p className="text-muted mb-0">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-users me-2 icon-sm"
                              >
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                <circle cx={9} cy={7} r={4} />
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                              </svg>
                              105.02k
                            </p>
                          </td>
                          <td className="text-end">
                            <p className="text-danger fw-medium fs-12 mb-0">
                              <i className="ri-arrow-down-s-fill fs-5 align-middle" />
                              10.52%
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h4 className="text-truncate fs-14 fs-medium mb-0">
                              <i className="ri-stop-fill align-middle fs-18 text-info me-2" />
                              Tablet Users
                            </h4>
                          </td>
                          <td>
                            <p className="text-muted mb-0">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-users me-2 icon-sm"
                              >
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                <circle cx={9} cy={7} r={4} />
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                              </svg>
                              42.89k
                            </p>
                          </td>
                          <td className="text-end">
                            <p className="text-danger fw-medium fs-12 mb-0">
                              <i className="ri-arrow-down-s-fill fs-5 align-middle" />
                              7.36%
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* end card body */}
              </div>
              {/* end card */}
            </div>
            {/* end col */}
            <div className="col-xl-4 col-md-6">
              <div className="card card-height-100">
                <div className="card-header align-items-center d-flex">
                  <h4 className="card-title mb-0 flex-grow-1">
                    Top Referrals Pages
                  </h4>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className="btn btn-soft-primary btn-sm shadow-none"
                    >
                      Export Report
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-6">
                      <h6 className="text-muted text-uppercase fw-semibold text-truncate fs-12 mb-3">
                        Total Referrals Page
                      </h6>
                      <h4 className="fs- mb-0">725,800</h4>
                      <p className="mb-0 mt-2 text-muted">
                        <span className="badge bg-success-subtle text-success mb-0">
                          <i className="ri-arrow-up-line align-middle" /> 15.72
                          %
                        </span>{" "}
                        vs. previous month
                      </p>
                    </div>
                    {/* end col */}
                    <div className="col-6">
                      <div className="text-center">
                        <img
                          src="assets/images/illustrator-1.png"
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                    </div>
                    {/* end col */}
                  </div>
                  {/* end row */}
                  <div className="mt-3 pt-2">
                    <div className="progress progress-lg rounded-pill">
                      <div
                        className="progress-bar bg-primary"
                        role="progressbar"
                        style={{ width: "25%" }}
                        aria-valuenow={25}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                      <div
                        className="progress-bar bg-info"
                        role="progressbar"
                        style={{ width: "18%" }}
                        aria-valuenow={18}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                      <div
                        className="progress-bar bg-success"
                        role="progressbar"
                        style={{ width: "22%" }}
                        aria-valuenow={22}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                      <div
                        className="progress-bar bg-warning"
                        role="progressbar"
                        style={{ width: "16%" }}
                        aria-valuenow={16}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                      <div
                        className="progress-bar bg-danger"
                        role="progressbar"
                        style={{ width: "19%" }}
                        aria-valuenow={19}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                    </div>
                  </div>
                  {/* end */}
                  <div className="mt-3 pt-2">
                    <div className="d-flex mb-2">
                      <div className="flex-grow-1">
                        <p className="text-truncate text-muted fs-14 mb-0">
                          <i className="mdi mdi-circle align-middle text-primary me-2" />
                          www.google.com
                        </p>
                      </div>
                      <div className="flex-shrink-0">
                        <p className="mb-0">24.58%</p>
                      </div>
                    </div>
                    {/* end */}
                    <div className="d-flex mb-2">
                      <div className="flex-grow-1">
                        <p className="text-truncate text-muted fs-14 mb-0">
                          <i className="mdi mdi-circle align-middle text-info me-2" />
                          www.youtube.com
                        </p>
                      </div>
                      <div className="flex-shrink-0">
                        <p className="mb-0">17.51%</p>
                      </div>
                    </div>
                    {/* end */}
                    <div className="d-flex mb-2">
                      <div className="flex-grow-1">
                        <p className="text-truncate text-muted fs-14 mb-0">
                          <i className="mdi mdi-circle align-middle text-success me-2" />
                          www.meta.com
                        </p>
                      </div>
                      <div className="flex-shrink-0">
                        <p className="mb-0">23.05%</p>
                      </div>
                    </div>
                    {/* end */}
                    <div className="d-flex mb-2">
                      <div className="flex-grow-1">
                        <p className="text-truncate text-muted fs-14 mb-0">
                          <i className="mdi mdi-circle align-middle text-warning me-2" />
                          www.medium.com
                        </p>
                      </div>
                      <div className="flex-shrink-0">
                        <p className="mb-0">12.22%</p>
                      </div>
                    </div>
                    {/* end */}
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-truncate text-muted fs-14 mb-0">
                          <i className="mdi mdi-circle align-middle text-danger me-2" />
                          Other
                        </p>
                      </div>
                      <div className="flex-shrink-0">
                        <p className="mb-0">17.58%</p>
                      </div>
                    </div>
                    {/* end */}
                  </div>
                  {/* end */}
                  <div className="mt-2 text-center">
                    <a
                      href="javascript:void(0);"
                      className="text-muted text-decoration-underline"
                    >
                      Show All
                    </a>
                  </div>
                </div>
                {/* end card body */}
              </div>
              {/* end card */}
            </div>
            {/* end col */}
            <div className="col-xl-4 col-md-6">
            <ReactApexChart options={data.options} series={data.series} type="bar" height={350} />
            
            </div>
            {/* end col */}
          </div>
          {/* end row */}




















          






          <div className="row">
            <div className="col-xl-6">
              <div className="card">
                <div className="card-header border-0 align-items-center d-flex">
                  <h4 className="card-title mb-0 flex-grow-1">
                    Audiences Metrics
                  </h4>
                  <div>
                    <button
                      type="button"
                      className="btn btn-soft-secondary btn-sm shadow-none"
                    >
                      ALL
                    </button>
                    <button
                      type="button"
                      className="btn btn-soft-secondary btn-sm shadow-none"
                    >
                      1M
                    </button>
                    <button
                      type="button"
                      className="btn btn-soft-secondary btn-sm shadow-none"
                    >
                      6M
                    </button>
                    <button
                      type="button"
                      className="btn btn-soft-primary btn-sm shadow-none"
                    >
                      1Y
                    </button>
                  </div>
                </div>
                {/* end card header */}
                <div className="card-header p-0 border-0 bg-light-subtle">
                  <div className="row g-0 text-center">
                    <div className="col-6 col-sm-4">
                      <div className="p-3 border border-dashed border-start-0">
                        <h5 className="mb-1">
                          <span className="counter-value" data-target={854}>
                            854
                          </span>
                          <span className="text-success ms-1 fs-12">
                            49%
                            <i className="ri-arrow-right-up-line ms-1 align-middle" />
                          </span>
                        </h5>
                        <p className="text-muted mb-0">Avg. Session</p>
                      </div>
                    </div>
                    {/*end col*/}
                    <div className="col-6 col-sm-4">
                      <div className="p-3 border border-dashed border-start-0">
                        <h5 className="mb-1">
                          <span className="counter-value" data-target={1278}>
                            1,278
                          </span>
                          <span className="text-success ms-1 fs-12">
                            60%
                            <i className="ri-arrow-right-up-line ms-1 align-middle" />
                          </span>
                        </h5>
                        <p className="text-muted mb-0">Conversion Rate</p>
                      </div>
                    </div>
                    {/*end col*/}
                    <div className="col-6 col-sm-4">
                      <div className="p-3 border border-dashed border-start-0 border-end-0">
                        <h5 className="mb-1">
                          <span className="counter-value" data-target={3}>
                            3
                          </span>
                          m
                          <span className="counter-value" data-target={40}>
                            40
                          </span>
                          sec
                          <span className="text-success ms-1 fs-12">
                            37%
                            <i className="ri-arrow-right-up-line ms-1 align-middle" />
                          </span>
                        </h5>
                        <p className="text-muted mb-0">Avg. Session Duration</p>
                      </div>
                    </div>
                    {/*end col*/}
                  </div>
                </div>
                {/* end card header */}
                <div className="card-body p-0 pb-2">
                  <div>
                    <div
                      id="audiences_metrics_charts"
                      data-colors='["--vz-success", "--vz-light"]'
                      className="apex-charts"
                      dir="ltr"
                      style={{ minHeight: 324 }}
                    >
                      <div
                        id="apexchartscjc6b0fm"
                        className="apexcharts-canvas apexchartscjc6b0fm apexcharts-theme-light"
                        style={{ width: 466, height: 309 }}
                      >
                        <svg
                          id="SvgjsSvg2023"
                          width={466}
                          height={309}
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          
                          className="apexcharts-svg"
                          
                          transform="translate(0, 0)"
                          style={{ background: "transparent" }}
                        >
                          <foreignObject x={0} y={0} width={466} height={309}>
                            <div
                              className="apexcharts-legend apexcharts-align-center apx-legend-position-bottom"
                        
                           style={{
                                inset: "auto 0px 5px 20px",
                                position: "absolute",
                                maxHeight: "154.5px"
                              }}
                            >
                              <div
                                className="apexcharts-legend-series"
                                rel={1}
                                seriesname="LastxYear"
                                
                                style={{ margin: "2px 5px" }}
                              >
                                <span
                                  className="apexcharts-legend-marker"
                                  rel={1}
                                  
                                  style={{
                                    background: "rgb(69, 203, 133) !important",
                                    color: "rgb(69, 203, 133)",
                                    height: 9,
                                    width: 9,
                                    left: 0,
                                    top: 0,
                                    borderWidth: 0,
                                    borderColor: "rgb(255, 255, 255)",
                                    borderRadius: 4
                                  }}
                                />
                                <span
                                  className="apexcharts-legend-text"
                                  rel={1}
                                  i={0}
                                 
                                  
                                  style={{
                                    color: "rgb(55, 61, 63)",
                                    fontSize: 8,
                                    fontWeight: 400,
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  Last Year
                                </span>
                              </div>
                              <div
                                className="apexcharts-legend-series"
                                rel={2}
                                seriesname="CurrentxYear"
                                
                                style={{ margin: "2px 5px" }}
                              >
                                <span
                                  className="apexcharts-legend-marker"
                                  rel={2}
                                  
                                  style={{
                                    background: "rgb(243, 246, 249) !important",
                                    color: "rgb(243, 246, 249)",
                                    height: 9,
                                    width: 9,
                                    left: 0,
                                    top: 0,
                                    borderWidth: 0,
                                    borderColor: "rgb(255, 255, 255)",
                                    borderRadius: 4
                                  }}
                                />
                                <span
                                  className="apexcharts-legend-text"
                                  rel={2}
                                  i={1}
                                  
                                  
                                  style={{
                                    color: "rgb(55, 61, 63)",
                                    fontSize: 8,
                                    fontWeight: 400,
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  Current Year
                                </span>
                              </div>
                            </div>
                            <style
                              type="text/css"
                              dangerouslySetInnerHTML={{
                                __html:
                                  "\t\n    \t\n      .apexcharts-legend {\t\n        display: flex;\t\n        overflow: auto;\t\n        padding: 0 10px;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {\t\n        flex-wrap: wrap\t\n      }\t\n      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\t\n        flex-direction: column;\t\n        bottom: 0;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\t\n        justify-content: flex-start;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {\t\n        justify-content: center;  \t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {\t\n        justify-content: flex-end;\t\n      }\t\n      .apexcharts-legend-series {\t\n        cursor: pointer;\t\n        line-height: normal;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series, .apexcharts-legend.apx-legend-position-top .apexcharts-legend-series{\t\n        display: flex;\t\n        align-items: center;\t\n      }\t\n      .apexcharts-legend-text {\t\n        position: relative;\t\n        font-size: 14px;\t\n      }\t\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {\t\n        pointer-events: none;\t\n      }\t\n      .apexcharts-legend-marker {\t\n        position: relative;\t\n        display: inline-block;\t\n        cursor: pointer;\t\n        margin-right: 3px;\t\n        border-style: solid;\n      }\t\n      \t\n      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{\t\n        display: inline-block;\t\n      }\t\n      .apexcharts-legend-series.apexcharts-no-click {\t\n        cursor: auto;\t\n      }\t\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {\t\n        display: none !important;\t\n      }\t\n      .apexcharts-inactive-legend {\t\n        opacity: 0.45;\t\n      }"
                              }}
                            />
                          </foreignObject>
                          <g
                            id="SvgjsG2141"
                            className="apexcharts-yaxis"
                            rel={0}
                            transform="translate(-18, 0)"
                          />
                          <g
                            id="SvgjsG2025"
                            className="apexcharts-inner apexcharts-graphical"
                            transform="translate(12, 30)"
                          >
                            <defs id="SvgjsDefs2024">
                              <linearGradient
                                id="SvgjsLinearGradient2027"
                                x1={0}
                                y1={0}
                                x2={0}
                                y2={1}
                              >
                                <stop
                                  id="SvgjsStop2028"
                                  stopOpacity="0.4"
                                  stopColor="rgba(216,227,240,0.4)"
                                  offset={0}
                                />
                                <stop
                                  id="SvgjsStop2029"
                                  stopOpacity="0.5"
                                  stopColor="rgba(190,209,230,0.5)"
                                  offset={1}
                                />
                                <stop
                                  id="SvgjsStop2030"
                                  stopOpacity="0.5"
                                  stopColor="rgba(190,209,230,0.5)"
                                  offset={1}
                                />
                              </linearGradient>
                              <clipPath id="gridRectMaskcjc6b0fm">
                                <rect
                                  id="SvgjsRect2032"
                                  width={450}
                                  height="221.40640030860902"
                                  x={-3}
                                  y={-1}
                                  rx={0}
                                  ry={0}
                                  opacity={1}
                                  strokeWidth={0}
                                  stroke="none"
                                  strokeDasharray={0}
                                  fill="#fff"
                                />
                              </clipPath>
                              <clipPath id="forecastMaskcjc6b0fm" />
                              <clipPath id="nonForecastMaskcjc6b0fm" />
                              <clipPath id="gridRectMarkerMaskcjc6b0fm">
                                <rect
                                  id="SvgjsRect2033"
                                  width={448}
                                  height="223.40640030860902"
                                  x={-2}
                                  y={-2}
                                  rx={0}
                                  ry={0}
                                  opacity={1}
                                  strokeWidth={0}
                                  stroke="none"
                                  strokeDasharray={0}
                                  fill="#fff"
                                />
                              </clipPath>
                            </defs>
                            <rect
                              id="SvgjsRect2031"
                              width="7.4"
                              height="219.40640030860902"
                              x={0}
                              y={0}
                              rx={0}
                              ry={0}
                              opacity={1}
                              strokeWidth={0}
                              strokeDasharray={3}
                              fill="url(#SvgjsLinearGradient2027)"
                              className="apexcharts-xcrosshairs"
                              y2="219.40640030860902"
                              filter="none"
                              fillOpacity="0.9"
                            />
                            <g id="SvgjsG2089" className="apexcharts-grid">
                              <g
                                id="SvgjsG2090"
                                className="apexcharts-gridlines-horizontal"
                                style={{ display: "none" }}
                              >
                                <line
                                  id="SvgjsLine2093"
                                  x1={0}
                                  y1={0}
                                  x2={444}
                                  y2={0}
                                  stroke="#e0e0e0"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                  className="apexcharts-gridline"
                                />
                                <line
                                  id="SvgjsLine2094"
                                  x1={0}
                                  y1="54.851600077152256"
                                  x2={444}
                                  y2="54.851600077152256"
                                  stroke="#e0e0e0"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                  className="apexcharts-gridline"
                                />
                                <line
                                  id="SvgjsLine2095"
                                  x1={0}
                                  y1="109.70320015430451"
                                  x2={444}
                                  y2="109.70320015430451"
                                  stroke="#e0e0e0"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                  className="apexcharts-gridline"
                                />
                                <line
                                  id="SvgjsLine2096"
                                  x1={0}
                                  y1="164.55480023145677"
                                  x2={444}
                                  y2="164.55480023145677"
                                  stroke="#e0e0e0"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                  className="apexcharts-gridline"
                                />
                                <line
                                  id="SvgjsLine2097"
                                  x1={0}
                                  y1="219.40640030860902"
                                  x2={444}
                                  y2="219.40640030860902"
                                  stroke="#e0e0e0"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                  className="apexcharts-gridline"
                                />
                              </g>
                              <g
                                id="SvgjsG2091"
                                className="apexcharts-gridlines-vertical"
                                style={{ display: "none" }}
                              />
                              <line
                                id="SvgjsLine2099"
                                x1={0}
                                y1="219.40640030860902"
                                x2={444}
                                y2="219.40640030860902"
                                stroke="transparent"
                                strokeDasharray={0}
                                strokeLinecap="butt"
                              />
                              <line
                                id="SvgjsLine2098"
                                x1={0}
                                y1={1}
                                x2={0}
                                y2="219.40640030860902"
                                stroke="transparent"
                                strokeDasharray={0}
                                strokeLinecap="butt"
                              />
                            </g>
                            <g
                              id="SvgjsG2034"
                              className="apexcharts-bar-series apexcharts-plot-series"
                            >
                              <g
                                id="SvgjsG2035"
                                className="apexcharts-series"
                                seriesname="LastxYear"
                                rel={1}
                                
                              >
                                <path
                                  id="SvgjsPath2039"
                                  d="M 14.8 219.40740030860903 L 14.8 150.02012621101144 L 20.200000000000003 150.02012621101144 L 20.200000000000003 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 14.8 219.40740030860903 L 14.8 150.02012621101144 L 20.200000000000003 150.02012621101144 L 20.200000000000003 219.40740030860903 z"
                                  pathfrom="M 14.8 219.40740030860903 L 14.8 219.40740030860903 L 20.200000000000003 219.40740030860903 L 20.200000000000003 219.40740030860903 L 20.200000000000003 219.40740030860903 L 20.200000000000003 219.40740030860903 L 20.200000000000003 219.40740030860903 L 14.8 219.40740030860903 z"
                                  cy="150.01912621101144"
                                  cx="50.8"
                                  j={0}
                                  val="25.3"
                                  barheight="69.3872740975976"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2041"
                                  d="M 51.8 219.40740030860903 L 51.8 185.12515026038886 L 57.199999999999996 185.12515026038886 L 57.199999999999996 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 51.8 219.40740030860903 L 51.8 185.12515026038886 L 57.199999999999996 185.12515026038886 L 57.199999999999996 219.40740030860903 z"
                                  pathfrom="M 51.8 219.40740030860903 L 51.8 219.40740030860903 L 57.199999999999996 219.40740030860903 L 57.199999999999996 219.40740030860903 L 57.199999999999996 219.40740030860903 L 57.199999999999996 219.40740030860903 L 57.199999999999996 219.40740030860903 L 51.8 219.40740030860903 z"
                                  cy="185.12415026038886"
                                  cx="87.8"
                                  j={1}
                                  val="12.5"
                                  barheight="34.282250048220156"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2043"
                                  d="M 88.8 219.40740030860903 L 88.8 164.00728423068526 L 94.2 164.00728423068526 L 94.2 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 88.8 219.40740030860903 L 88.8 164.00728423068526 L 94.2 164.00728423068526 L 94.2 219.40740030860903 z"
                                  pathfrom="M 88.8 219.40740030860903 L 88.8 219.40740030860903 L 94.2 219.40740030860903 L 94.2 219.40740030860903 L 94.2 219.40740030860903 L 94.2 219.40740030860903 L 94.2 219.40740030860903 L 88.8 219.40740030860903 z"
                                  cy="164.00628423068525"
                                  cx="124.8"
                                  j={2}
                                  val="20.2"
                                  barheight="55.40011607792378"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2045"
                                  d="M 125.8 219.40740030860903 L 125.8 168.6696702372432 L 131.2 168.6696702372432 L 131.2 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 125.8 219.40740030860903 L 125.8 168.6696702372432 L 131.2 168.6696702372432 L 131.2 219.40740030860903 z"
                                  pathfrom="M 125.8 219.40740030860903 L 125.8 219.40740030860903 L 131.2 219.40740030860903 L 131.2 219.40740030860903 L 131.2 219.40740030860903 L 131.2 219.40740030860903 L 131.2 219.40740030860903 L 125.8 219.40740030860903 z"
                                  cy="168.6686702372432"
                                  cx="161.8"
                                  j={3}
                                  val="18.5"
                                  barheight="50.73773007136583"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2047"
                                  d="M 162.8 219.40740030860903 L 162.8 108.60716815276147 L 168.20000000000002 108.60716815276147 L 168.20000000000002 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 162.8 219.40740030860903 L 162.8 108.60716815276147 L 168.20000000000002 108.60716815276147 L 168.20000000000002 219.40740030860903 z"
                                  pathfrom="M 162.8 219.40740030860903 L 162.8 219.40740030860903 L 168.20000000000002 219.40740030860903 L 168.20000000000002 219.40740030860903 L 168.20000000000002 219.40740030860903 L 168.20000000000002 219.40740030860903 L 168.20000000000002 219.40740030860903 L 162.8 219.40740030860903 z"
                                  cy="108.60616815276147"
                                  cx="198.8"
                                  j={4}
                                  val="40.4"
                                  barheight="110.80023215584755"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2049"
                                  d="M 199.8 219.40740030860903 L 199.8 149.74586821062567 L 205.20000000000002 149.74586821062567 L 205.20000000000002 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 199.8 219.40740030860903 L 199.8 149.74586821062567 L 205.20000000000002 149.74586821062567 L 205.20000000000002 219.40740030860903 z"
                                  pathfrom="M 199.8 219.40740030860903 L 199.8 219.40740030860903 L 205.20000000000002 219.40740030860903 L 205.20000000000002 219.40740030860903 L 205.20000000000002 219.40740030860903 L 205.20000000000002 219.40740030860903 L 205.20000000000002 219.40740030860903 L 199.8 219.40740030860903 z"
                                  cy="149.74486821062567"
                                  cx="235.8"
                                  j={5}
                                  val="25.4"
                                  barheight="69.66153209798335"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2051"
                                  d="M 236.8 219.40740030860903 L 236.8 176.07463624765873 L 242.20000000000002 176.07463624765873 L 242.20000000000002 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 236.8 219.40740030860903 L 236.8 176.07463624765873 L 242.20000000000002 176.07463624765873 L 242.20000000000002 219.40740030860903 z"
                                  pathfrom="M 236.8 219.40740030860903 L 236.8 219.40740030860903 L 242.20000000000002 219.40740030860903 L 242.20000000000002 219.40740030860903 L 242.20000000000002 219.40740030860903 L 242.20000000000002 219.40740030860903 L 242.20000000000002 219.40740030860903 L 236.8 219.40740030860903 z"
                                  cy="176.07363624765873"
                                  cx="272.8"
                                  j={6}
                                  val="15.8"
                                  barheight="43.33276406095028"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2053"
                                  d="M 273.8 219.40740030860903 L 273.8 158.24786622258426 L 279.2 158.24786622258426 L 279.2 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 273.8 219.40740030860903 L 273.8 158.24786622258426 L 279.2 158.24786622258426 L 279.2 219.40740030860903 z"
                                  pathfrom="M 273.8 219.40740030860903 L 273.8 219.40740030860903 L 279.2 219.40740030860903 L 279.2 219.40740030860903 L 279.2 219.40740030860903 L 279.2 219.40740030860903 L 279.2 219.40740030860903 L 273.8 219.40740030860903 z"
                                  cy="158.24686622258426"
                                  cx="309.8"
                                  j={7}
                                  val="22.3"
                                  barheight="61.15953408602476"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2055"
                                  d="M 310.8 219.40740030860903 L 310.8 166.74986423454286 L 316.2 166.74986423454286 L 316.2 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 310.8 219.40740030860903 L 310.8 166.74986423454286 L 316.2 166.74986423454286 L 316.2 219.40740030860903 z"
                                  pathfrom="M 310.8 219.40740030860903 L 310.8 219.40740030860903 L 316.2 219.40740030860903 L 316.2 219.40740030860903 L 316.2 219.40740030860903 L 316.2 219.40740030860903 L 316.2 219.40740030860903 L 310.8 219.40740030860903 z"
                                  cy="166.74886423454285"
                                  cx="346.8"
                                  j={8}
                                  val="19.2"
                                  barheight="52.65753607406616"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2057"
                                  d="M 347.8 219.40740030860903 L 347.8 150.02012621101144 L 353.2 150.02012621101144 L 353.2 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 347.8 219.40740030860903 L 347.8 150.02012621101144 L 353.2 150.02012621101144 L 353.2 219.40740030860903 z"
                                  pathfrom="M 347.8 219.40740030860903 L 347.8 219.40740030860903 L 353.2 219.40740030860903 L 353.2 219.40740030860903 L 353.2 219.40740030860903 L 353.2 219.40740030860903 L 353.2 219.40740030860903 L 347.8 219.40740030860903 z"
                                  cy="150.01912621101144"
                                  cx="383.8"
                                  j={9}
                                  val="25.3"
                                  barheight="69.3872740975976"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2059"
                                  d="M 384.8 219.40740030860903 L 384.8 185.12515026038886 L 390.2 185.12515026038886 L 390.2 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 384.8 219.40740030860903 L 384.8 185.12515026038886 L 390.2 185.12515026038886 L 390.2 219.40740030860903 z"
                                  pathfrom="M 384.8 219.40740030860903 L 384.8 219.40740030860903 L 390.2 219.40740030860903 L 390.2 219.40740030860903 L 390.2 219.40740030860903 L 390.2 219.40740030860903 L 390.2 219.40740030860903 L 384.8 219.40740030860903 z"
                                  cy="185.12415026038886"
                                  cx="420.8"
                                  j={10}
                                  val="12.5"
                                  barheight="34.282250048220156"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2061"
                                  d="M 421.8 219.40740030860903 L 421.8 164.00728423068526 L 427.2 164.00728423068526 L 427.2 219.40740030860903 z"
                                  fill="rgba(69,203,133,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={0}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 421.8 219.40740030860903 L 421.8 164.00728423068526 L 427.2 164.00728423068526 L 427.2 219.40740030860903 z"
                                  pathfrom="M 421.8 219.40740030860903 L 421.8 219.40740030860903 L 427.2 219.40740030860903 L 427.2 219.40740030860903 L 427.2 219.40740030860903 L 427.2 219.40740030860903 L 427.2 219.40740030860903 L 421.8 219.40740030860903 z"
                                  cy="164.00628423068525"
                                  cx="457.8"
                                  j={11}
                                  val="20.2"
                                  barheight="55.40011607792378"
                                  barwidth="7.4"
                                />
                                <g
                                  id="SvgjsG2037"
                                  className="apexcharts-bar-goals-markers"
                                  style={{ pointerEvents: "none" }}
                                >
                                  <g
                                    id="SvgjsG2038"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2040"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2042"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2044"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2046"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2048"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2050"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2052"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2054"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2056"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2058"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2060"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                </g>
                              </g>
                              <g
                                id="SvgjsG2062"
                                className="apexcharts-series"
                                seriesname="CurrentxYear"
                                rel={2}
                                
                              >
                                <path
                                  id="SvgjsPath2066"
                                  d="M 14.8 150.02112621101145 L 14.8 56.73973007136586 C 14.8 53.73973007136586 17.5 50.73973007136586 20.200000000000003 50.73973007136586 L 20.200000000000003 50.73973007136586 C 20.200000000000003 50.73973007136586 20.200000000000003 53.73973007136586 20.200000000000003 56.73973007136586 L 20.200000000000003 150.02112621101145 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 14.8 150.02112621101145 L 14.8 56.73973007136586 C 14.8 53.73973007136586 17.5 50.73973007136586 20.200000000000003 50.73973007136586 L 20.200000000000003 50.73973007136586 C 20.200000000000003 50.73973007136586 20.200000000000003 53.73973007136586 20.200000000000003 56.73973007136586 L 20.200000000000003 150.02112621101145 z "
                                  pathfrom="M 14.8 150.02112621101145 L 14.8 150.02112621101145 L 20.200000000000003 150.02112621101145 L 20.200000000000003 150.02112621101145 L 20.200000000000003 150.02112621101145 L 20.200000000000003 150.02112621101145 L 20.200000000000003 150.02112621101145 L 14.8 150.02112621101145 z"
                                  cy="50.738730071365865"
                                  cx="50.8"
                                  j={0}
                                  val="36.2"
                                  barheight="99.28139613964558"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2068"
                                  d="M 51.8 185.12615026038887 L 51.8 129.69235817397833 C 51.8 126.69235817397833 54.5 123.69235817397835 57.199999999999996 123.69235817397835 L 57.199999999999996 123.69235817397835 C 57.199999999999996 123.69235817397835 57.199999999999996 126.69235817397833 57.199999999999996 129.69235817397833 L 57.199999999999996 185.12615026038887 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 51.8 185.12615026038887 L 51.8 129.69235817397833 C 51.8 126.69235817397833 54.5 123.69235817397835 57.199999999999996 123.69235817397835 L 57.199999999999996 123.69235817397835 C 57.199999999999996 123.69235817397835 57.199999999999996 126.69235817397833 57.199999999999996 129.69235817397833 L 57.199999999999996 185.12615026038887 z "
                                  pathfrom="M 51.8 185.12615026038887 L 51.8 185.12615026038887 L 57.199999999999996 185.12615026038887 L 57.199999999999996 185.12615026038887 L 57.199999999999996 185.12615026038887 L 57.199999999999996 185.12615026038887 L 57.199999999999996 185.12615026038887 L 51.8 185.12615026038887 z"
                                  cy="123.69135817397834"
                                  cx="87.8"
                                  j={1}
                                  val="22.4"
                                  barheight="61.43379208641052"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2070"
                                  d="M 88.8 164.00828423068526 L 88.8 65.24172808332443 C 88.8 62.24172808332443 91.5 59.24172808332444 94.2 59.24172808332444 L 94.2 59.24172808332444 C 94.2 59.24172808332444 94.2 62.24172808332443 94.2 65.24172808332443 L 94.2 164.00828423068526 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 88.8 164.00828423068526 L 88.8 65.24172808332443 C 88.8 62.24172808332443 91.5 59.24172808332444 94.2 59.24172808332444 L 94.2 59.24172808332444 C 94.2 59.24172808332444 94.2 62.24172808332443 94.2 65.24172808332443 L 94.2 164.00828423068526 z "
                                  pathfrom="M 88.8 164.00828423068526 L 88.8 164.00828423068526 L 94.2 164.00828423068526 L 94.2 164.00828423068526 L 94.2 164.00828423068526 L 94.2 164.00828423068526 L 94.2 164.00828423068526 L 88.8 164.00828423068526 z"
                                  cy="59.24072808332444"
                                  cx="124.8"
                                  j={2}
                                  val="38.2"
                                  barheight="104.76655614736082"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2072"
                                  d="M 125.8 168.6706702372432 L 125.8 91.02198011958602 C 125.8 88.02198011958602 128.5 85.02198011958602 131.2 85.02198011958602 L 131.2 85.02198011958602 C 131.2 85.02198011958602 131.2 88.02198011958602 131.2 91.02198011958602 L 131.2 168.6706702372432 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 125.8 168.6706702372432 L 125.8 91.02198011958602 C 125.8 88.02198011958602 128.5 85.02198011958602 131.2 85.02198011958602 L 131.2 85.02198011958602 C 131.2 85.02198011958602 131.2 88.02198011958602 131.2 91.02198011958602 L 131.2 168.6706702372432 z "
                                  pathfrom="M 125.8 168.6706702372432 L 125.8 168.6706702372432 L 131.2 168.6706702372432 L 131.2 168.6706702372432 L 131.2 168.6706702372432 L 131.2 168.6706702372432 L 131.2 168.6706702372432 L 125.8 168.6706702372432 z"
                                  cy="85.02098011958601"
                                  cx="161.8"
                                  j={3}
                                  val="30.5"
                                  barheight="83.64869011765718"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2074"
                                  d="M 162.8 108.60816815276148 L 162.8 42.20405605092051 C 162.8 39.20405605092051 165.5 36.20405605092051 168.20000000000002 36.20405605092051 L 168.20000000000002 36.20405605092051 C 168.20000000000002 36.20405605092051 168.20000000000002 39.20405605092051 168.20000000000002 42.20405605092051 L 168.20000000000002 108.60816815276148 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 162.8 108.60816815276148 L 162.8 42.20405605092051 C 162.8 39.20405605092051 165.5 36.20405605092051 168.20000000000002 36.20405605092051 L 168.20000000000002 36.20405605092051 C 168.20000000000002 36.20405605092051 168.20000000000002 39.20405605092051 168.20000000000002 42.20405605092051 L 168.20000000000002 108.60816815276148 z "
                                  pathfrom="M 162.8 108.60816815276148 L 162.8 108.60816815276148 L 168.20000000000002 108.60816815276148 L 168.20000000000002 108.60816815276148 L 168.20000000000002 108.60816815276148 L 168.20000000000002 108.60816815276148 L 168.20000000000002 108.60816815276148 L 162.8 108.60816815276148 z"
                                  cy="36.20305605092051"
                                  cx="198.8"
                                  j={4}
                                  val="26.4"
                                  barheight="72.40411210184097"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2076"
                                  d="M 199.8 149.74686821062568 L 199.8 72.37243609335425 C 199.8 69.37243609335425 202.5 66.37243609335425 205.20000000000002 66.37243609335425 L 205.20000000000002 66.37243609335425 C 205.20000000000002 66.37243609335425 205.20000000000002 69.37243609335425 205.20000000000002 72.37243609335425 L 205.20000000000002 149.74686821062568 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 199.8 149.74686821062568 L 199.8 72.37243609335425 C 199.8 69.37243609335425 202.5 66.37243609335425 205.20000000000002 66.37243609335425 L 205.20000000000002 66.37243609335425 C 205.20000000000002 66.37243609335425 205.20000000000002 69.37243609335425 205.20000000000002 72.37243609335425 L 205.20000000000002 149.74686821062568 z "
                                  pathfrom="M 199.8 149.74686821062568 L 199.8 149.74686821062568 L 205.20000000000002 149.74686821062568 L 205.20000000000002 149.74686821062568 L 205.20000000000002 149.74686821062568 L 205.20000000000002 149.74686821062568 L 205.20000000000002 149.74686821062568 L 199.8 149.74686821062568 z"
                                  cy="66.37143609335425"
                                  cx="235.8"
                                  j={5}
                                  val="30.4"
                                  barheight="83.37443211727143"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2078"
                                  d="M 236.8 176.07563624765874 L 236.8 126.67552016973497 C 236.8 123.67552016973497 239.5 120.67552016973497 242.20000000000002 120.67552016973497 L 242.20000000000002 120.67552016973497 C 242.20000000000002 120.67552016973497 242.20000000000002 123.67552016973497 242.20000000000002 126.67552016973497 L 242.20000000000002 176.07563624765874 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 236.8 176.07563624765874 L 236.8 126.67552016973497 C 236.8 123.67552016973497 239.5 120.67552016973497 242.20000000000002 120.67552016973497 L 242.20000000000002 120.67552016973497 C 242.20000000000002 120.67552016973497 242.20000000000002 123.67552016973497 242.20000000000002 126.67552016973497 L 242.20000000000002 176.07563624765874 z "
                                  pathfrom="M 236.8 176.07563624765874 L 236.8 176.07563624765874 L 242.20000000000002 176.07563624765874 L 242.20000000000002 176.07563624765874 L 242.20000000000002 176.07563624765874 L 242.20000000000002 176.07563624765874 L 242.20000000000002 176.07563624765874 L 236.8 176.07563624765874 z"
                                  cy="120.67452016973496"
                                  cx="272.8"
                                  j={6}
                                  val="20.2"
                                  barheight="55.40011607792378"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2080"
                                  d="M 273.8 158.24886622258427 L 273.8 83.06849810839893 C 273.8 80.06849810839893 276.5 77.06849810839893 279.2 77.06849810839893 L 279.2 77.06849810839893 C 279.2 77.06849810839893 279.2 80.06849810839893 279.2 83.06849810839893 L 279.2 158.24886622258427 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 273.8 158.24886622258427 L 273.8 83.06849810839893 C 273.8 80.06849810839893 276.5 77.06849810839893 279.2 77.06849810839893 L 279.2 77.06849810839893 C 279.2 77.06849810839893 279.2 80.06849810839893 279.2 83.06849810839893 L 279.2 158.24886622258427 z "
                                  pathfrom="M 273.8 158.24886622258427 L 273.8 158.24886622258427 L 279.2 158.24886622258427 L 279.2 158.24886622258427 L 279.2 158.24886622258427 L 279.2 158.24886622258427 L 279.2 158.24886622258427 L 273.8 158.24886622258427 z"
                                  cy="77.06749810839892"
                                  cx="309.8"
                                  j={7}
                                  val="29.6"
                                  barheight="81.18036811418534"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2082"
                                  d="M 310.8 166.75086423454286 L 310.8 142.8567421924949 C 310.8 139.8567421924949 313.5 136.8567421924949 316.2 136.8567421924949 L 316.2 136.8567421924949 C 316.2 136.8567421924949 316.2 139.8567421924949 316.2 142.8567421924949 L 316.2 166.75086423454286 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 310.8 166.75086423454286 L 310.8 142.8567421924949 C 310.8 139.8567421924949 313.5 136.8567421924949 316.2 136.8567421924949 L 316.2 136.8567421924949 C 316.2 136.8567421924949 316.2 139.8567421924949 316.2 142.8567421924949 L 316.2 166.75086423454286 z "
                                  pathfrom="M 310.8 166.75086423454286 L 310.8 166.75086423454286 L 316.2 166.75086423454286 L 316.2 166.75086423454286 L 316.2 166.75086423454286 L 316.2 166.75086423454286 L 316.2 166.75086423454286 L 310.8 166.75086423454286 z"
                                  cy="136.8557421924949"
                                  cx="346.8"
                                  j={8}
                                  val="10.9"
                                  barheight="29.89412204204798"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2084"
                                  d="M 347.8 150.02112621101145 L 347.8 56.73973007136586 C 347.8 53.73973007136586 350.5 50.73973007136586 353.2 50.73973007136586 L 353.2 50.73973007136586 C 353.2 50.73973007136586 353.2 53.73973007136586 353.2 56.73973007136586 L 353.2 150.02112621101145 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 347.8 150.02112621101145 L 347.8 56.73973007136586 C 347.8 53.73973007136586 350.5 50.73973007136586 353.2 50.73973007136586 L 353.2 50.73973007136586 C 353.2 50.73973007136586 353.2 53.73973007136586 353.2 56.73973007136586 L 353.2 150.02112621101145 z "
                                  pathfrom="M 347.8 150.02112621101145 L 347.8 150.02112621101145 L 353.2 150.02112621101145 L 353.2 150.02112621101145 L 353.2 150.02112621101145 L 353.2 150.02112621101145 L 353.2 150.02112621101145 L 347.8 150.02112621101145 z"
                                  cy="50.738730071365865"
                                  cx="383.8"
                                  j={9}
                                  val="36.2"
                                  barheight="99.28139613964558"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2086"
                                  d="M 384.8 185.12615026038887 L 384.8 129.69235817397833 C 384.8 126.69235817397833 387.5 123.69235817397835 390.2 123.69235817397835 L 390.2 123.69235817397835 C 390.2 123.69235817397835 390.2 126.69235817397833 390.2 129.69235817397833 L 390.2 185.12615026038887 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 384.8 185.12615026038887 L 384.8 129.69235817397833 C 384.8 126.69235817397833 387.5 123.69235817397835 390.2 123.69235817397835 L 390.2 123.69235817397835 C 390.2 123.69235817397835 390.2 126.69235817397833 390.2 129.69235817397833 L 390.2 185.12615026038887 z "
                                  pathfrom="M 384.8 185.12615026038887 L 384.8 185.12615026038887 L 390.2 185.12615026038887 L 390.2 185.12615026038887 L 390.2 185.12615026038887 L 390.2 185.12615026038887 L 390.2 185.12615026038887 L 384.8 185.12615026038887 z"
                                  cy="123.69135817397834"
                                  cx="420.8"
                                  j={10}
                                  val="22.4"
                                  barheight="61.43379208641052"
                                  barwidth="7.4"
                                />
                                <path
                                  id="SvgjsPath2088"
                                  d="M 421.8 164.00828423068526 L 421.8 65.24172808332443 C 421.8 62.24172808332443 424.5 59.24172808332444 427.2 59.24172808332444 L 427.2 59.24172808332444 C 427.2 59.24172808332444 427.2 62.24172808332443 427.2 65.24172808332443 L 427.2 164.00828423068526 z "
                                  fill="rgba(243,246,249,1)"
                                  fillOpacity={1}
                                  stroke="transparent"
                                  strokeOpacity={1}
                                  strokeLinecap="round"
                                  strokeWidth={2}
                                  strokeDasharray={0}
                                  className="apexcharts-bar-area"
                                  index={1}
                                  clipPath="url(#gridRectMaskcjc6b0fm)"
                                  pathto="M 421.8 164.00828423068526 L 421.8 65.24172808332443 C 421.8 62.24172808332443 424.5 59.24172808332444 427.2 59.24172808332444 L 427.2 59.24172808332444 C 427.2 59.24172808332444 427.2 62.24172808332443 427.2 65.24172808332443 L 427.2 164.00828423068526 z "
                                  pathfrom="M 421.8 164.00828423068526 L 421.8 164.00828423068526 L 427.2 164.00828423068526 L 427.2 164.00828423068526 L 427.2 164.00828423068526 L 427.2 164.00828423068526 L 427.2 164.00828423068526 L 421.8 164.00828423068526 z"
                                  cy="59.24072808332444"
                                  cx="457.8"
                                  j={11}
                                  val="38.2"
                                  barheight="104.76655614736082"
                                  barwidth="7.4"
                                />
                                <g
                                  id="SvgjsG2064"
                                  className="apexcharts-bar-goals-markers"
                                  style={{ pointerEvents: "none" }}
                                >
                                  <g
                                    id="SvgjsG2065"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2067"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2069"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2071"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2073"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2075"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2077"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2079"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2081"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2083"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2085"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                  <g
                                    id="SvgjsG2087"
                                    classname="apexcharts-bar-goals-groups"
                                    className="apexcharts-hidden-element-shown"
                                    clipPath="url(#gridRectMarkerMaskcjc6b0fm)"
                                  />
                                </g>
                              </g>
                              <g
                                id="SvgjsG2036"
                                className="apexcharts-datalabels"
                                
                              />
                              <g
                                id="SvgjsG2063"
                                className="apexcharts-datalabels"
                                
                              />
                            </g>
                            <g
                              id="SvgjsG2092"
                              className="apexcharts-grid-borders"
                              style={{ display: "none" }}
                            />
                            <line
                              id="SvgjsLine2100"
                              x1={0}
                              y1={0}
                              x2={444}
                              y2={0}
                              stroke="#b6b6b6"
                              strokeDasharray={0}
                              strokeWidth={1}
                              strokeLinecap="butt"
                              className="apexcharts-ycrosshairs"
                            />
                            <line
                              id="SvgjsLine2101"
                              x1={0}
                              y1={0}
                              x2={444}
                              y2={0}
                              strokeDasharray={0}
                              strokeWidth={0}
                              strokeLinecap="butt"
                              className="apexcharts-ycrosshairs-hidden"
                            />
                            <g
                              id="SvgjsG2102"
                              className="apexcharts-xaxis"
                              transform="translate(0, 0)"
                            >
                              <g
                                id="SvgjsG2103"
                                className="apexcharts-xaxis-texts-g"
                                transform="translate(0, -4)"
                              >
                                <text
                                  id="SvgjsText2105"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="18.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2106">Jan</tspan>
                                  <title>Jan</title>
                                </text>
                                <text
                                  id="SvgjsText2108"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="55.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2109">Feb</tspan>
                                  <title>Feb</title>
                                </text>
                                <text
                                  id="SvgjsText2111"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="92.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2112">Mar</tspan>
                                  <title>Mar</title>
                                </text>
                                <text
                                  id="SvgjsText2114"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="129.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2115">Apr</tspan>
                                  <title>Apr</title>
                                </text>
                                <text
                                  id="SvgjsText2117"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="166.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2118">May</tspan>
                                  <title>May</title>
                                </text>
                                <text
                                  id="SvgjsText2120"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="203.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2121">Jun</tspan>
                                  <title>Jun</title>
                                </text>
                                <text
                                  id="SvgjsText2123"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="240.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2124">Jul</tspan>
                                  <title>Jul</title>
                                </text>
                                <text
                                  id="SvgjsText2126"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="277.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2127">Aug</tspan>
                                  <title>Aug</title>
                                </text>
                                <text
                                  id="SvgjsText2129"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="314.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2130">Sep</tspan>
                                  <title>Sep</title>
                                </text>
                                <text
                                  id="SvgjsText2132"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="351.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2133">Oct</tspan>
                                  <title>Oct</title>
                                </text>
                                <text
                                  id="SvgjsText2135"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="388.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2136">Nov</tspan>
                                  <title>Nov</title>
                                </text>
                                <text
                                  id="SvgjsText2138"
                                  fontFamily="Helvetica, Arial, sans-serif"
                                  x="425.5"
                                  y="248.40640030860902"
                                  textAnchor="middle"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#373d3f"
                                  className="apexcharts-text apexcharts-xaxis-label "
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                >
                                  <tspan id="SvgjsTspan2139">Dec</tspan>
                                  <title>Dec</title>
                                </text>
                              </g>
                              <line
                                id="SvgjsLine2140"
                                x1={0}
                                y1="220.40640030860902"
                                x2={444}
                                y2="220.40640030860902"
                                stroke="#e0e0e0"
                                strokeDasharray={0}
                                strokeWidth={1}
                                strokeLinecap="butt"
                              />
                            </g>
                            <g
                              id="SvgjsG2142"
                              className="apexcharts-yaxis-annotations"
                            />
                            <g
                              id="SvgjsG2143"
                              className="apexcharts-xaxis-annotations"
                            />
                            <g
                              id="SvgjsG2144"
                              className="apexcharts-point-annotations"
                            />
                          </g>
                        </svg>
                        <div className="apexcharts-tooltip apexcharts-theme-light">
                          <div
                            className="apexcharts-tooltip-title"
                            style={{
                              fontFamily: "Helvetica, Arial, sans-serif",
                              fontSize: 12
                            }}
                          />
                          <div
                            className="apexcharts-tooltip-series-group"
                            style={{ order: 1 }}
                          >
                            <span
                              className="apexcharts-tooltip-marker"
                              style={{ backgroundColor: "rgb(69, 203, 133)" }}
                            />
                            <div
                              className="apexcharts-tooltip-text"
                              style={{
                                fontFamily: "Helvetica, Arial, sans-serif",
                                fontSize: 12
                              }}
                            >
                              <div className="apexcharts-tooltip-y-group">
                                <span className="apexcharts-tooltip-text-y-label" />
                                <span className="apexcharts-tooltip-text-y-value" />
                              </div>
                              <div className="apexcharts-tooltip-goals-group">
                                <span className="apexcharts-tooltip-text-goals-label" />
                                <span className="apexcharts-tooltip-text-goals-value" />
                              </div>
                              <div className="apexcharts-tooltip-z-group">
                                <span className="apexcharts-tooltip-text-z-label" />
                                <span className="apexcharts-tooltip-text-z-value" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="apexcharts-tooltip-series-group"
                            style={{ order: 2 }}
                          >
                            <span
                              className="apexcharts-tooltip-marker"
                              style={{ backgroundColor: "rgb(243, 246, 249)" }}
                            />
                            <div
                              className="apexcharts-tooltip-text"
                              style={{
                                fontFamily: "Helvetica, Arial, sans-serif",
                                fontSize: 12
                              }}
                            >
                              <div className="apexcharts-tooltip-y-group">
                                <span className="apexcharts-tooltip-text-y-label" />
                                <span className="apexcharts-tooltip-text-y-value" />
                              </div>
                              <div className="apexcharts-tooltip-goals-group">
                                <span className="apexcharts-tooltip-text-goals-label" />
                                <span className="apexcharts-tooltip-text-goals-value" />
                              </div>
                              <div className="apexcharts-tooltip-z-group">
                                <span className="apexcharts-tooltip-text-z-label" />
                                <span className="apexcharts-tooltip-text-z-value" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-light">
                          <div className="apexcharts-yaxistooltip-text" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* end card body */}
              </div>
              {/* end card */}
            </div>
            {/* end col */}
            <div className="col-xl-6">
              <div className="card card-height-100">
                <div className="card-header align-items-center d-flex">
                  <h4 className="card-title mb-0 flex-grow-1">
                    Audiences Sessions by Country
                  </h4>
                  <div className="flex-shrink-0">
                    <div className="dropdown card-header-dropdown">
                      <a
                        className="text-reset dropdown-btn"
                        href="#"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span className="fw-semibold text-uppercase fs-12">
                          Sort by:{" "}
                        </span>
                        <span className="text-muted">
                          Current Week
                          <i className="mdi mdi-chevron-down ms-1" />
                        </span>
                      </a>
                      <div className="dropdown-menu dropdown-menu-end">
                        <a className="dropdown-item" href="#">
                          Today
                        </a>
                        <a className="dropdown-item" href="#">
                          Last Week
                        </a>
                        <a className="dropdown-item" href="#">
                          Last Month
                        </a>
                        <a className="dropdown-item" href="#">
                          Current Year
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                






                
              </div>
              {/* end card */}
            </div>
            {/* end col */}
          </div>
         
        </div>
   
   
   </>
    )
}

export default CompleteAnalytics